// extracted by mini-css-extract-plugin
module.exports = {"container":"SystemSettings_container__1OE89","container_title":"SystemSettings_container_title__1AQKU","container_text":"SystemSettings_container_text__3MwXv"};